export const sameDayCollectionMessage =
  'For collection today your gift will be ready 1 hour 30 minutes after we’ve received the order'
export const futureDayCollectionMessage =
  'Your gift will be made fresh on the day you have selected, please collect your gift 1 hour 30 minutes after the shop is open.'
export const oldCustomerAlertMessageFF =
  'Uh oh, looks like you’ve already ordered with us so you can’t use this code. Sorry!'
export const oldCustomerAlertMessageUK =
  'Sorry it looks like you’ve ordered with us before, so you can’t use this code.'
export const signInRegisterAlertMessageFF = 'To snag your first order discount, please'
export const signInRegisterAlertMessageUK = 'To get your first order discount please'
export const invalidPromoCodeAlertMessage = 'The promotional code you entered is not valid.'
export const promotionalCodeApplyError = 'There has been an error applying the promotional code, please try again.'
export const emailSubject = 'Problem changing privacy settings'
export const privacySuccessMessage = 'Your privacy settings have been saved.'
export const privacyErrorMessage = 'There was a problem. Please contact us at'
export const deliveryInstructionNote = 'Please be patient, untill i open the door'
export const deliveryInstructionOption = 'Please be patient'
export const deliveryInstructionOptionNotToshow = 'Press to select'
export const deliveryInstructionLable = 'Delivery instructions'
export const ERROR_TOWN_LIST_PREFIX = 'Error retrieving a list of towns for'
export const ERROR_COUNTY_LIST_PREFIX = 'Error retrieving a list of counties for'
export const FLORISTS_NEAR_YOU = 'Florists near'
export const CHANGE_FLORIST = 'Change florist'
export const START_NEW_SEARCH = 'Start new search'
export const SEARCH_NEW_ADDRESS = 'Search new address'
export const LOAD_MORE_FLORISTS = 'Load more florists'
export const SELECT_FLORIST = 'Select florist'

export const OCCASION_REQUIRED_MESSAGE = 'Please select an occasion'

export const DELIVERY_INSTRUCTION_LINK = 'Want to add extra delivery instructions?'
export const DAYPICKER_ERROR_MESSAGE = 'Select a delivery date'

export const CHOOSE_DATE = 'Choose a date'
export const CHOOSE_ADDRESS = 'Choose a delivery address'
export const CHOOSE_AN_OCCASION = 'Choose an occasion'
export const INTERNATIONAL_DELIVERY = 'International delivery'
export const ENTER_DELIVERY_ADDRESS = 'Enter delivery address'
export const LIST_VIEW = 'List View'
export const MAP_VIEW = 'Map View'

export const RECOMMENDED = 'Recommended'
export const READ_TIME = 'Read time - {count} mins'
export const READ_MORE = 'Read more'
export const READ_LESS = 'Read less'
export const collectionInstructionsTitle = 'Collection instructions'
export const collectionText =
  'The florist will need a minimum of 1 hour 30 minutes to prepare your flowers, but you can specify a preferred collection time below'
export const collectionInstructionPlaceholder = 'For example...\n1.30pm (in my lunch break)'

export const OCCASION_PERSONALISED_MESSAGES = {
  "Mother's Day": 'Happy Mother’s Day.\n\nLots of love,',
  Birthday: 'Happy birthday! Hope you have a brilliant day.',
  Friendship: 'Thanks for being an amazing friend.',
  Sympathy: 'I’m so sorry, sending all my love.',
  'Thinking of You': 'Thinking of you and sending love.',
  'Thank You': 'Thank you so much for everything!',
  Anniversary: 'Happy anniversary to my special someone.',
}
export const PDP_COLLECTION_STEP_2_TITLE = 'Would you like your order delivered?'
export const PDP_DELIVERY_STEP_2_TITLE = 'Who is this gift for?'

export const PRODUCTDETAIL = 'ProductDetail'
export const standardDeliveryType = 'Delivery'
export const collectionDeliveryType = 'Collection'

export const COLLECT_FROM_FLORIST = 'Collect from florist'
export const deliveryTypes = [
  { title: 'Delivery', icon: 'local_shipping', description: 'by local florist', cta_label: 'Next: Delivery date' },
  { title: 'Collection', icon: 'store', description: 'from local florist', cta_label: 'Next: Collection date' },
]

export const CTA_ADDRESS_FF = 'Next: Delivery date'
export const CTA_ADDRESS_IF_MOBILE = 'Next'

export const FREE_LABEL = 'FREE'

export const ADDRESS_PLACEHOLDER_EIRCODE = 'Try the eircode or street name'
export const ADDRESS_PLACEHOLDER_COLLECTION = 'Enter town or postcode'
export const ADDRESS_PLACEHOLDER_COLLECTION_IE = 'Try the town or eircode'
export const ADDRESS_PLACEHOLDER_DELIVERY = 'Enter delivery postcode'
export const PDP_COLLECTION_STEP_3_TITLE = 'When and where would you like to collect your gift?'
export const PDP_FF_DELIVERY_STEP_3_TITLE = 'Choose a delivery date'
export const PDP_DROPSHIP_STEP_3_TITLE = 'When would you like your gift to be delivered?'
export const PDP_STEP_3_TITLE = 'When would you like your gift?'
export const DELIVERY_OPTION_TITLE = 'Select a delivery option for'

export const COLLECTION_OPTION_TITLE = 'Collect from florist on'
export const COLLECTION_ADDRESS_LABEL = 'Search for collection address'
export const COLLECTION_ADDRESS_PLACEHOLDER = 'Search for town'
export const COLLECTION_ADDRESS_REQUIRED_MESSAGE = 'Please select an address from the list'
export const COUNTRY_REQUIRED_ERROR_MESSAGE = 'Please select a country'
export const COLLECTION_AVAILABILITY_ERROR_MESSAGE = 'The collection availability check returned an error response:'

export const UNAVAILABLE_MODAL_TITLE = 'We can’t quite do that'
export const COLLECTION_UNAVAILABLE_MODAL_DESCRIPTION = `We're really sorry, but you can’t collect the `
export const COLLECTION_UNAVAILABLE_MODAL_DESCRIPTION_2 = 'from that location on that day.'
export const COLLECTION_UNAVAILABLE_MODAL_SUB_DESCRIPTION = 'Choose one of the following instead:'
export const CHOOSE_DELIVERY_OPTION = 'Choose a delivery option'
export const CHANGE_COLLECTION_ADDRESS = 'Change collection address'
export const CHANGE_DELIVERY_DATE = 'Choose a different date'
export const STEM_SPECIFIC_PRICING = {
  displayText: 'Choose number of ',
  descriptionText: 'Same day delivery available for up to ',
}
export const SPECIAL_INSTRUCTIONS_TITLE = 'Do you have any special requests?'
export const STEMS_SPECIFIC_TITLE = 'How many {stems} would you like?'
export const VARIANT_TITLE = 'What {variant} would you like?'
export const NO_SPECIAL_INSTRUCTIONS_LABEL = '(No special request entered)'
export const FROM = 'From'

export const VIEW_AVAILABLE_GIFTS = 'View available gifts'
export const VIEW_SUITABLE_GIFTS = 'View suitable gifts'
export const SAVE_OCCASION = 'Save occasion'

export const PCC_EDIT_TRACKING_LOCATION = {
  1: 'date',
  2: 'address',
  3: 'occasion',
}

export const COLLECTION_DETAILS_TITLES = {
  selectedFloristShop: 'Your selected florist shop:',
  collectionFrom: 'Collection From:',
  collectFromFlorist: 'Collect from florist',
  emailNotification: 'You’ll be sent an email when it’s ready to collect',
}
export const PRODUCT_QUERY_PARAMS = 'productQueryParams'
export const INTERNATIONAL = 'international'
